import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=325c4b0f&scoped=true&lang=pug&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=325c4b0f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c4b0f",
  null
  
)

export default component.exports